/**
 * @file     withAppointedLink.tsx
 * @purpose  Renders copy that marks "appointed" with <appointed>...</appointed> so the word links to the Referral Disclosure; untagged copy passes through unchanged.
 */
import Link from 'next/link';
import type { ReactNode } from 'react';
import { routes } from '@/core/constants/routes';

const APPOINTED_TAG = /<appointed>(.*?)<\/appointed>/;

export function withAppointedLink(text: string): ReactNode {
  const match = APPOINTED_TAG.exec(text);
  if (!match) return text;
  return (
    <>
      {text.slice(0, match.index)}
      <Link href={routes.disclosure} style={{ color: 'inherit', textDecoration: 'underline' }}>
        {match[1]}
      </Link>
      {text.slice(match.index + match[0].length)}
    </>
  );
}
